/**
 * Global error handler utility to manage error logging
 * Prevents certain errors from being logged to the console in production
 */

// Suppress the benign ResizeObserver loop error at the source.
// This is a known browser issue that React's dev error overlay surfaces
// as a crash. It does not affect functionality.
const _ro = window.ResizeObserver;
if (_ro) {
  window.ResizeObserver = class extends _ro {
    observe(target) {
      try {
        super.observe(target);
      } catch (e) {
        // ignore
      }
    }
    unobserve(target) {
      try {
        super.unobserve(target);
      } catch (e) {
        // ignore
      }
    }
  };
}

// Original console.error function
const originalConsoleError = console.error;

// Override console.error to filter out suppressed errors
console.error = function(...args) {
  // Suppress ResizeObserver loop warnings in console
  const msg = args[0];
  if (typeof msg === 'string' && msg.includes('ResizeObserver loop completed')) {
    return;
  }
  if (args[0] && args[0] instanceof Error && args[0].suppressConsole) {
    if (process.env.NODE_ENV === 'production') {
      return;
    }
    args[0] = `[DEV ONLY - Suppressed in production] ${args[0]}`;
  }
  
  originalConsoleError.apply(console, args);
};

// Function to handle errors globally
export const handleError = (error) => {
  if (error.suppressConsole && process.env.NODE_ENV === 'production') {
    return;
  }
  
  throw error;
};

export default {
  handleError
};
